import { DEPLOYMENT_CONSTANTS } from "./constants";
import { GridItem, Heading, SimpleGrid } from "@chakra-ui/react";
import { AdvantageCard } from "../advantages/card";

const DeploymentComponent = () => {
  return (
    <SimpleGrid columns={{ base: 1, sm: 3, md: 4 }} spacing={12}>
      <GridItem colSpan={{ base: 1, sm: 3, md: 1 }} alignSelf={"center"}>
        <Heading as="h2" fontWeight={"400"} fontSize={"40px"}>
          Deployment Options
        </Heading>
      </GridItem>
      {DEPLOYMENT_CONSTANTS.map((item, index) => (
        <GridItem key={index}>
          <AdvantageCard
            text={item.text}
            image={item.image}
            title={item.title}
            bgColor={"#F9FAFC"}
            borderColor={"primary.300"}
          />
        </GridItem>
      ))}
    </SimpleGrid>
  );
};

export default DeploymentComponent;
